import { z } from 'zod';
import { scanStateSchema } from './enums';
/**
 * Images/screenshots/PDFs only, per the requirements doc ("Images,
 * Screenshots, PDF documents, Supporting files"). Deliberately narrow rather
 * than "any file type" — office-document types can be added here later the
 * same way TRIGGER_LANGUAGES grows, without touching anything else that
 * reads this list (the API's multipart validation and the web app's
 * `<input accept="...">` both import from here, so there is exactly one
 * place this ever needs to change).
 */
export const ALLOWED_ATTACHMENT_CONTENT_TYPES = [
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'application/pdf',
];
export const allowedAttachmentContentTypeSchema = z.enum(ALLOWED_ATTACHMENT_CONTENT_TYPES);
/**
 * Default cap on a single upload. The API's actual enforcement point is
 * `ATTACHMENT_MAX_FILE_SIZE_MB` in env.ts (configurable without a code
 * change); this constant is what the web app checks against before ever
 * starting an upload, so a too-large file fails instantly instead of after a
 * slow round trip. The two should be kept in step by whoever changes either.
 */
export const DEFAULT_ATTACHMENT_MAX_FILE_SIZE_MB = 10;
/** What the API returns for an existing attachment. */
export const attachmentSchema = z.object({
    id: z.string(),
    topicId: z.string().nullable(),
    commentId: z.string().nullable(),
    uploadedById: z.string(),
    uploadedByDisplayName: z.string(),
    fileName: z.string(),
    contentType: z.string(),
    sizeBytes: z.number(),
    scanState: scanStateSchema,
    createdAt: z.coerce.date(),
});
/**
 * The non-file fields that travel alongside the upload in the same
 * multipart body. `piiAcknowledged` must arrive as the literal string
 * `'true'` — multipart fields are always strings, and requiring the literal
 * (rather than coercing "yes"/"1"/etc.) keeps the checkbox's contract exact:
 * un-checked or omitted both fail closed.
 */
export const uploadAttachmentFieldsSchema = z.object({
    piiAcknowledged: z.literal('true', {
        message: 'You must confirm this file contains no client personal information',
    }),
});
//# sourceMappingURL=attachments.js.map